import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161a8eb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","text-align":"justify"} }
const _hoisted_2 = { style: {"padding-left":"35px"} }
const _hoisted_3 = { style: {"padding-left":"35px"} }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  class: "card",
  style: {"margin":"10px"}
}
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "text-lg bold" }
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-start"} }
const _hoisted_9 = {
  class: "text-xl bold",
  style: {"text-align":"left","padding-right":"5px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "objects: ", -1))
const _hoisted_11 = {
  key: 0,
  style: {"text-align":"left","padding":"10px 10px 20px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No objects", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { style: {"display":"flex","justify-content":"flex-start","padding-left":"10px","padding-top":"15px"} }
const _hoisted_15 = { style: {"text-align":"left"} }
const _hoisted_16 = { class: "record-list" }
const _hoisted_17 = { class: "record" }
const _hoisted_18 = { style: {"padding-left":"10px"} }
const _hoisted_19 = { class: "key" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"flex-start","padding-left":"10px","padding-bottom":"15px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"left"} }, "}")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"5px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.jsonData, (workflow) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(workflow.workflowName), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(workflow.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workflow.states, (state) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(state.description), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.nodes, (node) => {
              return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(node.name), 1),
                  _hoisted_10
                ]),
                (node.objects.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.objects, (persistentObject) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(persistentObject.name) + " {", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(persistentObject.records, (record) => {
                      return (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                        _createElementVNode("li", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(record.key) + ":", 1),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(record.value), 1)
                          ])
                        ])
                      ]))
                    }), 256)),
                    _hoisted_21
                  ]))
                }), 256))
              ]))
            }), 256))
          ]))
        }), 256))
      ]),
      _hoisted_22
    ]))
  }), 256))
}